
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getDepartmentList, delDepartment } from '@/api/company';
import { UserModule } from '@/store/modules/user';
import { parseTime } from '@/utils/index';
import DialogSetStaff from '@/views/staff/components/setStaff.vue';

@Component({
  name: 'Department',
  components: {
    DialogSetStaff
  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  isCheckboxDept!: Boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  isSearchDept!: Boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  isDialogDept!: Boolean;

  @Prop({
    type: Array,
    default: []
  })
  columnItemData!: [];

  @Prop({
    type: Object,
    default: () => ({})
  })
  pagination!: any;

  @Prop({
    type: Object,
    default: () => ({})
  })
  searchData!: any;

  private tableloading = false
  private tableData = []
  private tableDataLower2 = []
  private tableDataLower3 = []
  private tableDataLower4 = []
  private tableDataLower5 = []
  private tableDataLower6 = []
  private tableDataLower7 = []
  private tableDataLower8 = []

  private expands: any = []
  private expands2: any = []
  private expands3: any = []
  private expands4: any = []
  private expands5: any = []
  private expands6: any = []
  private expands7: any = []
  private expands8: any = []

  private getRowKey(row: any) {
    return row.id;
  }

  private deptId = ''
  private enterType=1;

  created() {
    this.getDepartmentList(0, 1);
  }

  private getDepartmentList(deptPid:any, lev:number) {
    const params:any = {
      company_id: UserModule.getCompanyId,
      type: '9', // type=9 查所有部门  type=2查服务部门
      page: this.pagination.page,
      size: this.pagination.pageSize,
      is_multi_level: 1,
      dept_pid: deptPid
    };

    let tableContainer = 'tableDataLower' + lev;
    let expandsContainer = 'expands' + (lev - 1);
    if (lev > 1) {
      params.page = 1;
      params.size = 9999;
      this.$data[tableContainer] = [];
    }
    if (lev === 1) {
      this.tableloading = true;
    }
    getDepartmentList(params)
      .then(res => {
        switch (lev) {
          case 1:
            if (res.data) {
              this.tableloading = false;
              this.pagination.total = res.data.count;

              if (this.isDialogDept) {
                if (this.pagination.page === 1) {
                  this.tableData = res.data.list;
                } else {
                  this.tableData = this.tableData.concat(res.data.list);
                }
              } else {
                this.tableData = res.data.list;
              }

              this.paseData(this.tableData);
            } else {
              this.pagination.total = 0;
              this.tableData = [];
            }
            break;
          case 2:
            if (res.data) {
              this.tableDataLower2 = res.data.list;
              this.paseData(this.tableDataLower2);
            } else {
              this.tableDataLower2 = [];
            }
            break;
          case 3:
            if (res.data) {
              this.tableDataLower3 = res.data.list;
              this.paseData(this.tableDataLower3);
            } else {
              this.tableDataLower3 = [];
            }
            break;
          case 4:
            if (res.data) {
              this.tableDataLower4 = res.data.list;
              this.paseData(this.tableDataLower4);
            } else {
              this.tableDataLower4 = [];
            }
            break;
          case 5:
            if (res.data) {
              this.tableDataLower5 = res.data.list;
              this.paseData(this.tableDataLower5);
            } else {
              this.tableDataLower5 = [];
            }
            break;
          case 6:
            if (res.data) {
              this.tableDataLower6 = res.data.list;
              this.paseData(this.tableDataLower6);
            } else {
              this.tableDataLower6 = [];
            }
            break;
          case 7:
            if (res.data) {
              this.tableDataLower7 = res.data.list;
              this.paseData(this.tableDataLower7);
            } else {
              this.tableDataLower7 = [];
            }
            break;
          case 8:
            if (res.data) {
              this.tableDataLower8 = res.data.list;
              this.paseData(this.tableDataLower8);
            } else {
              this.tableDataLower8 = [];
            }
            break;
        }
      })
      .catch(err => {
        let msg = err.msg;
      });

    if (lev === 2) {
      if (this.expands.includes(deptPid)) {
        this.expands = this.expands.filter((val: any) => val !== deptPid);
      } else {
        if (this.expands.length !== 0) {
          this.expands.splice(0, this.expands.length);
          this.expands.push(deptPid);
        } else {
          this.expands.push(deptPid);
        }
      }
    } else if (lev === 3 || lev === 4 || lev === 5 || lev === 6 || lev === 7 || lev === 8) {
      if (this.$data[expandsContainer].includes(deptPid)) {
        this.$data[expandsContainer] = this.$data[expandsContainer].filter((val: any) => val !== deptPid);
      } else {
        if (this.$data[expandsContainer].length !== 0) {
          this.$data[expandsContainer].splice(0, this.$data[expandsContainer].length);
          this.$data[expandsContainer].push(deptPid);
        } else {
          this.$data[expandsContainer].push(deptPid);
        }
      }
    }
  }
  private getDepartmentListAll() {
    this.tableloading = true;
    const params:any = {
      company_id: UserModule.getCompanyId,
      type: '9', // type=9 查所有部门  type=2查服务部门
      page: this.pagination.page,
      size: this.pagination.pageSize,
      dept_pid: 0
    };
    if (this.searchData.deptmentName) {
      params.name = this.searchData.deptmentName;
    }
    if (this.searchData.area) {
      params.address = this.searchData.area;
    }
    getDepartmentList(params)
      .then(res => {
        if (res.data) {
          this.tableloading = false;

          if (this.isDialogDept) {
            if (this.pagination.page === 1) {
              this.tableData = res.data.list;
            } else {
              this.tableData = this.tableData.concat(res.data.list);
            }
          } else {
            this.tableData = res.data.list;
          }

          this.pagination.total = res.data.count;
          this.$emit('totalData', this.pagination.total);

          this.paseData(this.tableData);
        } else {
          this.pagination.total = 0;
          this.tableData = [];
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }

  // 展开行操作
  private expandChange(row: any, expandedRows : any) {
    this.getDepartmentList(row.id, 2);
  }
  private expandChange2(row: any, expandedRows : any) {
    this.getDepartmentList(row.id, 3);
  }
  private expandChange3(row: any, expandedRows : any) {
    this.getDepartmentList(row.id, 4);
  }
  private expandChange4(row: any, expandedRows : any) {
    this.getDepartmentList(row.id, 5);
  }
  private expandChange5(row: any, expandedRows : any) {
    this.getDepartmentList(row.id, 6);
  }
  private expandChange6(row: any, expandedRows : any) {
    this.getDepartmentList(row.id, 7);
  }
  private expandChange7(row: any, expandedRows : any) {
    this.getDepartmentList(row.id, 8);
  }

  paseData(val:any) {
    for (let i = 0; i < val.length; i++) {
      let cont:any = val[i];
      cont.area = val[i].province_name + val[i].city_name + val[i].district_name;
      cont.addTimeStr = parseTime(cont.addtime, '{y}-{m}-{d} {h}:{i}');
      this.$set(val, cont, i);
    }
  }

  // 复选框
  private checkboxSelected: any = []
  private checkedSelectedChange(val: any) {
    if (this.isCheckboxDept) {
      this.$emit('checkboxData', val);
    }
  }

  // 列表操作 编辑
  private editorStaffHandle(val:any) {
    let formDept = {
      dept_id: val.dept_id,
      name: val.name,
      sort: val.sort,
      area: [val.province, val.city, val.district],
      serviceDept: parseInt(val.dept_type) === 2,
      publicDept: parseInt(val.is_common) === 1,
      province: val.province,
      province_name: val.province_name,
      city: val.city,
      city_name: val.city_name,
      district: val.district,
      district_name: val.district_name,
      dialogAddDeptVisible: true
    };
    if ((this.columnItemData as any)[3].checked) {
      this.$emit('editData', formDept);
    }
  }

  // 列表操作 人员
  private dialogSetStaffVisible = false;
  private deleteStaffHandle(val:any) {
    this.enterType = 2;
    this.deptId = val.dept_id;
    this.dialogSetStaffVisible = true;
  }
  private addStaffHandle(val:any) {
    this.enterType = 1;
    this.deptId = val.dept_id;
    this.dialogSetStaffVisible = true;
  }
  closeSetStaff(value: boolean) {
    // if (this.isSearchDept) {
    //   this.getDepartmentListAll();
    // } else {
    //   this.expands = [];
    //   this.expands2 = [];
    //   this.expands3 = [];
    //   this.expands4 = [];
    //   this.expands5 = [];
    //   this.expands6 = [];
    //   this.expands7 = [];
    //   this.expands8 = [];
    //   this.getDepartmentList(0, 1);
    // }
    this.dialogSetStaffVisible = value;
  }

  private deleteHandle(val:any) {
    let _this = this;
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        _this.delStaffDepartment(val.dept_id);
      })
      .catch(() => {});
  }
  // 删除部门
  private delStaffDepartment(id:string) {
    let _this = this;
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.id = id;
    delDepartment(params).then(res => {
      _this.$notify({
        title: '提示',
        message: (res as any).msg,
        offset: window.innerHeight * 0.4,
        customClass: 'notification-center',
        type: 'success'
      });
      if (_this.isSearchDept) {
        _this.getDepartmentListAll();
      } else {
        _this.getDepartmentList(0, 1);
      }
    }).catch(err => {
      _this.$notify({
        title: '提示',
        message: err.msg,
        offset: 100,
        type: 'error'
      });
    });
  }
}
